import React from "react";
import { Col, Row } from "react-bootstrap";
import HireUsModal from "./HireUsModal";
import { motion } from "framer-motion";

const perks = [
  {
    icon: "fa-bolt",
    label: "Rapid Delivery",
    desc: "From concept to deployment — we ship custom-built software at speeds no traditional agency can match.",
  },
  {
    icon: "fa-gift",
    label: "7-Day Free Trial",
    desc: "Test any product with real data. Zero commitment, no credit card required.",
  },
  {
    icon: "fa-microchip",
    label: "AI-First Design",
    desc: "Every system ships with intelligent automation, predictive analytics, and smart workflows.",
  },
  {
    icon: "fa-lock",
    label: "Full Ownership",
    desc: "You own the code, the data, and the IP. No vendor lock-in, no surprises.",
  },
];

const stats = [
  { num: "50+", label: "Projects Delivered" },
  { num: "6+", label: "Products In Suite" },
  { num: "100%", label: "AI Powered" },
  { num: "24/7", label: "Support Available" },
];

function HireusComponent() {
  return (
    <div className="hireus-section-new">
      <div className="container">
        <Row>
          <Col xs={12} md={6}>
            <motion.div
              className="hireus-text"
              initial={{ opacity: 0, x: -40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="section-badge">Why Choose Us</div>
              <h3>
                Why <span style={{ color: "#63FFCD" }}>GoWave</span>?
              </h3>
              <p className="hireus-desc">
                GoWave is a registered partnership firm building AI-powered
                enterprise software. We don't sell generic tools — every product
                is intelligently designed and shaped around your business model.
              </p>
              <div className="perks-grid-new">
                {perks.map((p, i) => (
                  <motion.div
                    key={p.label}
                    className="perk-card-new"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: i * 0.1 }}
                    whileHover={{ scale: 1.03 }}
                  >
                    <div className="perk-icon-new">
                      <span className={`fa ${p.icon}`}></span>
                    </div>
                    <div>
                      <strong>{p.label}</strong>
                      <p className="perk-desc-new">{p.desc}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
              <HireUsModal />
            </motion.div>
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex align-items-center justify-content-center"
          >
            <motion.div
              className="stats-grid-new"
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  className="stat-card-new"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: 0.3 + i * 0.1 }}
                  whileHover={{ y: -5 }}
                >
                  <span className="stat-num-new">{s.num}</span>
                  <span className="stat-label-new">{s.label}</span>
                </motion.div>
              ))}
            </motion.div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default HireusComponent;
